import { Reset } from "@/modules/auth/common/enum";
import { CloudflareAsset } from "@/shared/common/enums";
import { CloudFlareImage, PasswordRules } from "@/shared/components";
import { FormField } from "@ab.uitools/ui-library/components/FormField";
import { Input } from "@ab.uitools/ui-library/components/Input";
import type { ISVGIconProps } from "@ab.uitools/ui-library/components/SVGIcons/types";
import { useFormProps } from "@ab.uitools/ui-library/hooks/useFormProps";
import { useState } from "react";
import { useTranslation } from "react-i18next";

export const NewPasswordFormFields = () => {
  const { t } = useTranslation();
  const { watch } = useFormProps();

  const [isPasswordShow, setIsPasswordShow] = useState<boolean>(false);
  const [isRepeatPasswordShow, setIsRepeatPasswordShow] = useState<boolean>(false);

  const password = watch?.(Reset.Password);

  return (
    <>
      <FormField
        name="password"
        className="mt-24"
        errorMessageIcon="infoFilled"
        As={(props) => (
          <Input
            {...props}
            required
            type={isPasswordShow ? "text" : "password"}
            className="mt-24"
            label={t("auth.newPassword.newPassword")}
            rightIconProps={{
              Component: (props: ISVGIconProps) => (
                <CloudFlareImage
                  {...props}
                  path={isPasswordShow ? CloudflareAsset.EyeClose : CloudflareAsset.EyeOpen}
                />
              ),
              onClick() {
                setIsPasswordShow((prev: boolean) => !prev);
              },
            }}
          />
        )}
      />
      <PasswordRules className="mt-12" password={password}/>
      <FormField
        name="confirmPassword"
        errorMessageIcon="infoFilled"
        As={(props) => (
          <Input
            {...props}
            required
            type={isRepeatPasswordShow ? "text" : "password"}
            className="mt-24"
            label={t("auth.newPassword.repeatPassword")}
            rightIconProps={{
              Component: (props: ISVGIconProps) => isRepeatPasswordShow ? (
                <CloudFlareImage {...props} path={CloudflareAsset.EyeClose}/>
              ) : (
                <CloudFlareImage {...props} path={CloudflareAsset.EyeOpen}/>
              ),
              onClick() {
                setIsRepeatPasswordShow((prev: boolean) => !prev);
              },
            }}
          />
        )}
      />
    </>
  );
};
